import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../../../app.config';
import { urlJoin } from '../../../../core/helpers/url.helper';
import { FinancingRequest } from './demat-delivery/demat-delivery.component.model';
import { Observable } from 'rxjs';
import { createHeaders } from '@tribeauto/ngx-mobilite-material';

@Injectable({
  providedIn: 'root'
})
export class FinancialContractService {
  private readonly httpClient = inject(HttpClient);
  private readonly appConfig = inject(AppConfig);

  private readonly url = urlJoin(this.appConfig.url, 'financial-contract');

  financeRequest(webstoreId: string, contractId: string, financingRequest: FinancingRequest): Observable<void> {
    return this.httpClient.post<void>(
      urlJoin(this.url, 'webstores', webstoreId, 'contracts', contractId, 'financingRequest'),
      financingRequest,
      { headers: createHeaders() }
    );
  }
}
